import React from "react";

const AICaseGenerator = ({ caseText, onClose }) => {
  return (
    <div className="mt-6 p-6 bg-indigo-50/50 rounded-2xl border border-indigo-100 animate-fade">
      <div className="flex justify-between items-start mb-2">
        <p className="text-[10px] font-black text-indigo-500 uppercase">
          ✨ Caso Práctico por IA
        </p>
        <button
          onClick={onClose}
          className="text-indigo-400 hover:text-indigo-600 transition-colors"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div className="text-sm text-slate-700 italic leading-relaxed">
        {caseText || "Generando caso realista..."}
      </div>
    </div>
  );
};

export default AICaseGenerator;
